// extracted by mini-css-extract-plugin
module.exports = {"item":"item-3fU5D"};